import React, { PureComponent } from 'react';
import Landing from '../Landing';
import LandingTelmex from '../LandingTelmex';
import { isLandingTelmexEnabled } from 'src/utils/Utils';

export default class LandingResolver extends PureComponent {
  render() {
    const isLandingTelmex = isLandingTelmexEnabled();

    return isLandingTelmex ? (
      <LandingTelmex {...this.props} />
    ) : (
      <Landing {...this.props} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingResolver/index.jsx